import { AlpineComponent } from 'alpinejs';
import Chart from 'chart.js/auto';
import ChartDeferred from 'chartjs-plugin-deferred';

const ChartLineComponent = (): AlpineComponent => ({
  init() {

    const SELECTOR_CHART_LINE_INIT = this.$root;

    if (!SELECTOR_CHART_LINE_INIT) return;

    const CHART_DATA = JSON.parse(SELECTOR_CHART_LINE_INIT.getAttribute('data-data'));
    const CHART_LABELS = CHART_DATA.map(el => el.dataset_data.map(el2 => el2.col1));
    const CHART_DATASETS = CHART_DATA.map(el => {
      return {
        label: el.title,
        data: el.dataset_data.map(el2 => Number(el2.col2)),
        borderColor: el.dataset_color.color[0].color,
        backgroundColor: el.dataset_color.color[0].color
      }
    });
        
    const data = {
      labels: CHART_LABELS[0],
      datasets: CHART_DATASETS
    };
    
    const config = {
      plugins: [ChartDeferred,
        {
          id: "increase-legend-spacing",
          beforeInit(chart: any) {
            // Get reference to the original fit function
            const originalFit = (chart.legend as any).fit;
            // Override the fit function
            (chart.legend as any).fit = function fit() {
              // Call original function and bind scope in order to use `this` correctly inside it
              originalFit.bind(chart.legend)();
              this.height += 20;
            };
          }
        }
      ],
      type: 'line',
      data,
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            position: 'top',
            labels: {
              usePointStyle: true,
              padding: 20
            }
          },
          title: {
            display: false,
            text: 'Line Chart'
          },
          deferred: {
            yOffset: '100%',
            delay: 100
          }
        },
        scales: {
          y: {
            type: 'linear',
            display: true,
            position: 'left',
            ticks: {
              padding: 20
            }
          },
          x: {
            ticks: {
              padding: 20
            }
          }
        },
        animation: {
          duration: 600,
          easing: 'ease-out',
        },
        layout: {
          padding: {
            top: 10,
            bottom: 10
          },
        },
      }
    };

    new Chart(
      SELECTOR_CHART_LINE_INIT,
      config
    );
  }
});

export default ChartLineComponent;
